import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';
import adapter from './chats.adapter';
import { REDUCER_KEY } from './chats.consts';
import { ChatsParams } from './chats.types';

const selectors = adapter.getSelectors(
  (state: RootState) => state[REDUCER_KEY],
);
export const { selectIds, selectTotal, selectAll } = selectors;

export const selectById = (state: RootState, id: number): ChatsParams | null =>
  selectors.selectById(state, id) || null;

export function selectChat(
  state: RootState,
  chatId: number,
): ChatsParams | undefined {
  return selectors.selectById(state, chatId) || undefined;
}

export const selectChatMessagesById = createSelector(
  [(state: RootState, chatId: number) => selectors.selectById(state, chatId)],
  (chat): ChatsParams['messages'] => {
    const messages = chat ? chat.messages : [];
    return [...messages].sort(
      (a, b) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );
  },
);
